import styled from 'styled-components'
import { rem } from 'polished'
import Group from 'components/utils/Group'
import BodyText from 'LuxKit/Typography/BodyText'
import IconButton from 'LuxKit/Button/IconButton'
import LineCornerDownRightIcon from 'LuxKit/Icons/line/LineCornerDownRightIcon'
import LineTimesIcon from 'LuxKit/Icons/line/LineTimesIcon'

const ChatInputContextBarContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: ${props => props.theme.palette.highlight.primary.lightBackground};
  border-radius: ${props => props.theme.borderRadius.L};
  padding: ${rem(12)} ${rem(20)} ${rem(20)} ${rem(20)};
  margin-bottom: ${rem(-8)};
  position: relative;
  z-index: 0;
`

interface ChatInputContextBarProps {
  label: string
  onClose: () => void
}

function ChatInputContextBar({ label, onClose }: ChatInputContextBarProps) {
  return (
    <ChatInputContextBarContainer>
      <Group direction="horizontal" gap={12} verticalAlign="center">
        <LineCornerDownRightIcon />
        <BodyText variant="medium">
          {label}
        </BodyText>
      </Group>
      <IconButton kind="tertiary" size="small" onClick={onClose}>
        <LineTimesIcon />
      </IconButton>
    </ChatInputContextBarContainer>
  )
}

export default ChatInputContextBar
